import api from 'api';

export const startIntegration = api('PUT /api/integrations/start');

export const stopIntegration = api('PUT /api/integrations/stop');

export const removeIntegration = api('POST /api/integrations/delete');

export const batchStartIntegration = api('PUT /api/integrations/bulk/start');

export const batchStopIntegration = api('PUT /api/integrations/bulk/stop');

export const batchRemoveIntegration = api('POST /api/integrations/bulk/delete');

export const exportIntegrations = api('POST /api/integrations/export', {
  responseType: 'blob',
});
